<template>
  <div>
    <mdb-input type="text" v-model="imageUrl" :required="required"
               :label="label">
       <span slot="append">
         <mdb-file-input img sm textFieldTitle="" :width="100" :src="imageUrl" v-on:getValue="uploadFile"/>
       </span>
    </mdb-input>

  </div>
</template>

<script>

import {mdbFileInput, mdbInput} from 'mdbvue';
import api from "../../services/groupsPlaceApi";

export default {
  name: 'system-image-selector',
  components: {
    mdbInput,
    mdbFileInput
  },
  watch: {
    imageUrl(n) {
      this.$emit("imageChanged", {fieldName: this.fieldName, url: n})
    }
  },
  data() {
    return {}
  },
  props: {
    imageUrl: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "Image URL"
    },
    fieldName: {
      type: String,
      default: "image"
    }

  },
  methods: {
    uploadFile: async function (file) {
      await this.$store.dispatch("setExecuting", true)
      api.postImage("/image/create?folder=pasted", file[0]).then(
        (results) => {
          this.$notify.success({message: "Image uploaded successfully.", timeOut: 3000})
          this.imageUrl = results.data.image.url
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
  }
};
</script>
